<div class="paginator-wrapper">
    <span class="signpost">Items Per page:</span>
    <app-paginator-selector 
      [items]="items" 
      [selected]="selected" 
      (selectionChange)="onPageSizeSelected($event)">
    </app-paginator-selector>
    <div class="range-info">
      <span class="metadata">
        <strong>{{ ((currentPage - 1) * pageSize) + 1 }}</strong>
        to 
        <span>{{ currentPage * pageSize > resultsLength ? resultsLength : currentPage * pageSize }}</span>
        of
        <strong>{{ resultsLength }}</strong>
      </span>
    </div>
    <div class="paginator-nav">
      <button (click)="goToFirstPage()" [disabled]="isFirstPage">
        <mat-icon>first_page</mat-icon>
      </button>
      <button class="arrow_back_ios" (click)="goToPreviousPage()" [disabled]="isFirstPage">
        <mat-icon>arrow_back_ios</mat-icon>
      </button>
      <span class="signpost">Page <strong>{{ currentPage }}</strong> of <strong>{{ totalPages }}</strong></span>
      <button class="arrow_back_ios" (click)="goToNextPage()" [disabled]="isLastPage">
        <mat-icon>arrow_forward_ios</mat-icon>
      </button>
      <button (click)="goToLastPage()" [disabled]="isLastPage">
        <mat-icon>last_page</mat-icon>
      </button>
    </div>
  </div>